import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Alert } from '@app/ui';
import { ArrowLeftOutlined, InfoCircleFilled } from '@ant-design/icons';
import { useBroadcastsContext } from '../BroadcastsContext';
import '../styles/FiltersOverrideRow.scss';

const FiltersOverrideRow = () => {
    const { t } = useTranslation('measurement');
    const { filtersOverride, onGoBackToInsights } = useBroadcastsContext();

    if (!filtersOverride) return null;

    return (
        <div className="filters-override-row">
            <Button
                type="primary"
                icon={<ArrowLeftOutlined />}
                onClick={onGoBackToInsights}
                className="filters-override-row__button"
                style={{ fontFamily: 'pnregular' }}
            >
                {t('common:buttons.returnToDataExplorer')}
            </Button>
            <Alert
                message={t('broadcastExposure.filtersOverride.alertMessage')}
                type="info"
                showIcon
                icon={<InfoCircleFilled style={{ color: '#009FDF' }} />}
                className="filters-override-row__alert"
                style={{ fontFamily: 'pnregular' }}
            />
        </div>
    );
};

export default FiltersOverrideRow;
